const NoPage = () => {
    return <h1>This page could not be found.</h1>;
};

export default NoPage;